"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Snackbar.default;
  }
});

var _Snackbar = _interopRequireDefault(require("./Snackbar"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Snackbar/index.js
// module id = 661
// module chunks = 0